import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PoEmailHeaderQuoteService {
  private proposalNumber$ = new BehaviorSubject<boolean>(false);
  selectedproposalNumber$ = this.proposalNumber$.asObservable();

  onRushSelection(event: boolean) {
    this.proposalNumber$.next(event);
  }
}
